<template>
    <div class="picker-container">
        <transition name="enable-scanner">
            <div
                class="picking-list__barcode"
                v-if="useScanner"
                :class="{ 'picking-list__barcode--active': isScanning }"
                :style="{
                transform: `translateX(${x - 72}px) translateY(${y -
                    22}px)`,
                }"
            ></div>
        </transition>
        <div class="d-flex justify-content-between">
            <div>
                <p class="title">Picking List</p>
                <p class="address">WooCommerce | www.dartshopzaanstand.nl</p>
            </div>
            <div>
                <p class="address text-right">Printed: 01/20/2022 at 09:53 AM</p>
                <p class="address text-right">1 order</p>
            </div>
        </div>
        <table 
            class="table table-style"
            @mouseenter="useScanner = true"
            @mouseleave="useScanner = false"
            @mouseup="isScanning = false"
        >
            <thead>
                <tr>
                    <th scope="col" class="header-style col-3">Order</th>
                    <th scope="col" class="header-style col-9">Items</th>
                </tr>
            </thead>
            <tbody>
                <tr 
                    v-for="(order, index) in orders" 
                    @mouseover="hovered = index" 
                    @mouseleave="hovered = null" 
                    @click="openModal(index)"
                    :key="index"
                    :class="hovered != index ? 'opacity-active' : ''">
                    <td class="row-style col-4">
                        <div class="d-flex">
                            <div>
                                <p class="order-list-label">ORDER ID</p>
                                <p class="order-list-label">Customer</p>
                            </div>
                            <div class="ml-3">
                                <p class="order-list-data">80345</p>
                                <p class="order-list-data">NL order-boxmaster</p>
                            </div>
                        </div>
                        <img src="~@/assets/pack_go/barcode-image.png" width="100%"/>
                    </td>
                    <td class="row-style col-8">
                        <table class="table property-table">
                            <thead>
                                <tr>
                                    <th scope="col" class="col-8 text-center property-table-header order-list-label">Properties</th>
                                    <th scope="col" class="col-3 text-center property-table-header order-list-label">SKU</th>
                                    <th scope="col" class="col-1 text-center property-table-header order-list-label">QTY</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(list, index) in order['lists']" :key="index">
                                    <td class="col-8 property-table-data">
                                        <div class="d-flex">
                                            <div>
                                                <img v-if="list.image === 1" src="~@/assets/pack_go/thumb-tiny-image-1.png" class="property-table-data-img"/>
                                                <img v-if="list.image === 2" src="~@/assets/pack_go/thumb-tiny-image-2.png" class="property-table-data-img"/>
                                                <img v-if="list.image === 3" src="~@/assets/pack_go/thumb-tiny-image-3.png" class="property-table-data-img"/>
                                                <img v-if="list.image === 4" src="~@/assets/pack_go/thumb-tiny-image-4.png" class="property-table-data-img"/>
                                            </div>
                                            <div class="ml-1 mt-auto mb-auto">
                                                <p class="order-list-label">{{ list.name }}</p>
                                                <div style="margin-left: 0.5rem">
                                                    <p class="order-list-label" v-for="spec in list.specs">{{ spec.label }} - {{ spec.data }}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td class="col-3 property-table-data">
                                        <p class="order-list-label">{{ list.SKU }}</p>
                                    </td>
                                    <td class="col-1 property-table-data">
                                        <p class="order-list-label text-center">{{ list.qty }}</p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
            </tbody>
        </table>
        <p class="address mt-5">Page 1/5</p>
    </div>
</template>

<script>
export default {
    data() {
        return {
            hovered: null,
            x: null,
            y: null,
            isScanning: false,
            useScanner: false,
            orders: [
                {
                    lists: [
                        {
                            image: 1,
                            name: 'Large Picture Frame',
                            specs: [
                                {
                                    label: 'Size',
                                    data: 'Large'
                                },
                                {
                                    label: 'Color',
                                    data: 'Gray'
                                }
                            ],
                            SKU: '41-FB-2010',
                            qty: 2
                        },
                        {
                            image: 2,
                            name: 'Antique Fruit Bowl',
                            specs: [],
                            SKU: '87-CB-45BB',
                            qty: 1
                        },
                        {
                            image: 3,
                            name: 'Baja Wall Rack',
                            specs: [
                                {
                                    label: 'Color',
                                    data: 'white'
                                }
                            ],
                            SKU: '19-AV-6747',
                            qty: 2
                        }
                    ]
                },
                {
                    lists: [
                        {
                            image: 1,
                            name: 'Large Picture Frame',
                            specs: [
                                {
                                    label: 'Size',
                                    data: 'Large'
                                },
                                {
                                    label: 'Color',
                                    data: 'Gray'
                                }
                            ],
                            SKU: '41-FB-2010',
                            qty: 2
                        },
                        {
                            image: 2,
                            name: 'Antique Fruit Bowl',
                            specs: [],
                            SKU: '87-CB-45BB',
                            qty: 1
                        },
                    ]
                },
                {
                    lists: [
                        {
                            image: 3,
                            name: 'Baja Wall Rack',
                            specs: [
                                {
                                    label: 'Color',
                                    data: 'white'
                                }
                            ],
                            SKU: '19-AV-6747',
                            qty: 2
                        }
                    ]
                }
            ]
        }
    },
    methods: {
        handleMouseMove(event) {
            this.x = event.clientX;
            this.y = event.clientY;
        },
        openModal(order) {
            this.$emit('open-modal', order)
        }
    },
    created() {
        document.addEventListener("mousemove", this.handleMouseMove);
    },
    destroyed() {
        document.removeEventListener("mousemove", this.handleMouseMove);
    },
}
</script>

<style>
.picker-container {
    padding: 25px;
    border: 1px solid #E8E8E8;
    border-radius: 8px;
}

.title {
    font-family: 'Source Sans Pro';
    font-style: normal;
    font-weight: 600;
    font-size: 0.8rem;
    margin-bottom: 0px;
    color: #212121;
}

.address {
    font-family: 'Source Sans Pro';
    font-style: normal;
    font-weight: 400;
    font-size: 0.5rem;
    color: #212121;
    margin-bottom: 0px;
}

.table-style {
    margin-top: 10px;
    cursor: pointer;
}

.header-style {
    border: none !important;
    padding: 10px 0px !important;
    font-size: 0.6rem !important;
}

.row-style {
    padding: 0px !important;
}

.order-list-label {
    font-family: 'Source Sans Pro';
    font-style: normal;
    font-weight: 400;
    font-size: 0.5rem;
    color: #686868;
    margin-bottom: 0px;
}

.order-list-data {
    font-family: 'Source Sans Pro';
    font-style: normal;
    font-weight: 400;
    font-size: 0.5rem;
    color: #212121;
    margin-bottom: 0px;
}

.property-table {
    margin-bottom: 0px !important;
}

.property-table-header {
    padding: 1px !important;
    border-left: 1px solid #E8E8E8;
    border-right: 1px solid #E8E8E8;
    border-bottom: 1px solid #E8E8E8 !important;
    border-top: none !important;
}

.property-table-data {
    padding: 3px !important;
    border-width: 0px 1px 1px 1px !important;
    border-style: dashed !important;
    border-color: #E7E7E7 !important;
}

.property-table-data-img {
    border-radius: 6px;
    width: 50px;
    height: 50px;
}

.opacity-active {
    opacity: 0.2;
}

.enable-scanner-enter-active,
.enable-scanner-leave-active {
    transition: opacity 0.5s ease, width 0.5s ease;
}
.enable-scanner-enter,
.enable-scanner-leave-to {
    opacity: 0;
    width: 0;
}

.picking-list__barcode {
    position: fixed;
    z-index: auto;
    display: flex;
    width: 150px;
    animation: barcode-animation;
    animation-duration: 100ms;
    animation-iteration-count: infinite;
    pointer-events: none;
    top: 25px;
    left: 25px;
    height: 2px;
    background: rgb(255, 238, 238);
    border-radius: 3px;
    z-index: 1000;
    box-shadow: 1px 1px 7px 10px rgba(255, 0, 0, 0.33),
        0px 0px 3px 1px rgba(255, 115, 115, 0.84),
        0px 0px 0px 0px rgba(255, 25, 25, 0.94),
        0px 0px 26px 26px rgba(255, 4, 4, 0.23);
}

.picking-list__barcode--active {
    animation: barcode-active-animation;
    animation-duration: 100ms;
    animation-iteration-count: infinite;
}
</style>